import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../../services/authService/authService';
import { ROUTES } from '../../constants';
import AuthPage from '../../features/auth/AuthPage';

const Home: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    if (isAuthenticated()) {
      navigate(ROUTES.DASHBOARD);
    }
  }, [navigate]);

  // If not authenticated, show the auth page
  return <AuthPage />;
};

export default Home; 